module.exports = __webpack_public_path__ + "static/media/payment-guidance-icon.cc1c4e8f.svg";